import apiUrl from '../../../constants'
import axios from 'axios'
import iptrackerdetails from '../../../iptrackerdetails'

import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
/*----tree structure--*/
import {LOAD_CHILDREN_OPTIONS,Treeselect} from '@riophae/vue-treeselect'
  // import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css';
/*----//tree structure--*/


export default {
    name: 'appuserprojectroles',
    components: {
        Paginate,
        VueElementLoading,
        Treeselect
    },
    data: function() {

        return {
            modalShow: false,
            updateusermodal: false,
            editusermodal: false,
            addusermodal: false,
            useraction: '',
            listUserData: [],
            listRoleData: [],
            listProjectData: [],
            iptrackData:'',
            props: [],
            pageno: 0,
            pagecount: 0,
            username: '',
            userid: '',
            rolename: '',
            isLoading: false,
            resultCount: '',
            adduser: {
                firstname: '',
                username: '',
                email: '',
                password: '',
                confirmpassword: '',
                usertype: '',
            },
            roleid: '',
            status: '',
            projectid: [],
            projectroleid: [],
            status: '',
            changestatus: '',
            count: 0,
            email: '',
            localuserid: 0,
            show:false,
            multiple: 0,
            options: [],
            selected: '',
            //projectidwiserole: [],
            form: {
                projectidwiserole: [],
                values:[],
                projectidchk:[]
            }
        }
    },
    created: function() {

    },
    mounted() {

        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.iptrackData = userdetail
        this.localuserid = userdetail.userid;
        this.pageno = 0;
        this.getProjectData();
        this.getOvverideData();
    },
    methods: {
        addNewUser() {
            this.adduser.firstname = '',
            this.adduser.username = '',
            this.adduser.email = '',
            this.adduser.password = '',
            this.adduser.confirmpassword = '',
            this.status = '1',
            this.roleid = '',
            this.projectid = [],
            this.projectroleid = [],
            this.adduser.usertype = '',
            this.useraction = 'add',
            this.addusermodal = true,
            this.$validator.reset();
            this.errors.clear();
        },

        //to get project and role list
        getProjectData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.input = ({
              userid : this.$route.params.id
            });
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getSingleUserProjectsList',
                data: this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then(result => {
                if(result.data.length > 0)
                {
                  this.listProjectData = result.data;
                }else{
                  this.$alertify.error("Project data not available for this user");
                  this.$router.push('/user');
                }
            }, error => {
                console.error(error)
            })
        },
        //to get project and role list
        getOvverideData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.input = ({
              userid : this.$route.params.id
            });
            this.show = true;
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getSingleUserOvveridedData',
                data: this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
            .then(result => {
                let self =this;
                let selectedTreeVal = [];
                let checkVal = {};
                var val = "";
                let i=0;
                let m=0;
                let tempArr=[];
                let tempArr1=[];

                var output = {};
                result.data.forEach(function(item,i) {
                  if(tempArr1.indexOf(item.projectid)===-1){
                    output[item.projectid]=[{"projectid":item.projectid,"roleId":item.roleId,"childId":item.childId,"parentId":item.parentId,"parentName":item.parentName,"childData":item.childData}];
                    tempArr1.push(item.projectid);
                    //tempArr=[];
                  }else{
                    //console.log(item.projectid);
                      output[item.projectid].push({"projectid":item.projectid,"roleId":item.roleId,"childId":item.childId,"parentId":item.parentId,"parentName":item.parentName,"childData":item.childData});

                  }
                });
                //console.log("output",output);
                var temp = {};
                let arr=[];
                let tempArr2=[];
                let j=0;
                for (var key in output) {
                  //console.log("output[key]",output[key]);
                  let newObj=output[key];
                  //console.log(newObj.length);
                  newObj.map(function(item){
                    //console.log("item",item);
                    if(item.childData.length>0){
                      item.childData.map((childObj, index)=>{
                        if(childObj.parentid==0){
                          arr.push(childObj.permissionid+"@"+childObj.permissionid+"@@"+childObj.permissionname);
                        }else{
                          arr.push(childObj.parentid+"@"+childObj.permissionid+"@@"+childObj.permissionname);
                        }
                      });
                    }else{
                      arr.push(item.parentId+"@"+item.parentName);
                    }
                    //console.log(arr);
                    item.arr=arr;
                    // console.log("arr",arr);
                    self.getProjectModuleTree(item.projectid,j,null,item.roleId, item, "edit");
                    // //this.$forceUpdate();

                  })
                  this.$forceUpdate();
                  arr=[];
                  //
                  j++;
                }
                this.show = false;
            }, error => {
                console.error(error)
            })
        },
        compare(a,b) {
            if (a.projectid < b.projectid)
              return -1;
            if (a.projectid > b.projectid)
              return 1;
            return 0;
        },
        saveOverrideModule() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            let tempArr=[];
            this.show = true;
            this.form.projectidchk.map((obj,key) =>{
               if(obj){
                 var rObj = {};
                 let temp = []
                 let arr=this.form.values[key];
                 let result = this.listProjectData.filter(obj1 => {
                    return parseInt(obj1.projectid) === key
                 })
                 arr.map((obj1)=>{
                   let objArr={};
                   let arrValue=obj1.split('@');
                   if(!isNaN(parseInt(arrValue[0]))){
                      objArr.mainid=parseInt(arrValue[0])
                   }
                   if(!isNaN(parseInt(arrValue[1]))){
                      objArr.child=parseInt(arrValue[1])
                   }
                   temp.push(objArr);
                  })
                 tempArr.push({"projects":key,
                 "roles":result[0].roleid,"urls":temp})
                }
              });
              this.input = ({
                  userid : this.$route.params.id,
                  loginUserId : this.localuserid,
                  projectArr: tempArr
              });
              axios({
                method: 'POST',
                'url': apiUrl.api_url + 'SubmitOvverideModuleData',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
              })
              .then((response) => {
                this.show = false;
                if(response.status == 200)
                {
                  this.$alertify.success(response.data.msg);
                  this.$router.push('/user');
                }else{
                  this.$alertify.success("Ovveriding failed");
                  this.$router.push('/user');
                }
                iptrackerdetails.checkUserIP(this.iptrackData,'Override Module Access',this.$route.path,this.input,response.data);

              })
              .catch((httpException) => {
                console.error('exception is:::::::::', httpException)
              })
        },

        getUserRowData(data) {
            this.$validator.reset();
            this.errors.clear();
            this.useraction = 'edit';
            this.addusermodal = true;
            this.adduser.firstname = data.firstname;
            this.adduser.username = data.username;
            this.adduser.email = data.email;
            this.adduser.usertype = data.utype;
            this.adduser.password = data.password;
            this.roleid = data.roleid;
            this.adduser.password = data.password;
            this.userid = data.userid;
            this.projectid = data.projectid;
            this.projectroleid = data.projectroleid;
            this.status = data.status;
        },
        onSubmit: function(event) {
          //let OneBoxChecked = this.valthisform();
          let TreeselectErr = false;
          // let OneCheckBoxErr = false;
          // if(OneBoxChecked == false)
          // {
          //   OneCheckBoxErr = true;
          //   document.getElementById("form_errors").innerHTML="Please check atleast one check box";
          // }else{
          //   OneCheckBoxErr = false;
          // }

          if(TreeselectErr == false)
          {
            var checkboxs = document.getElementsByName("projectIdCheck");
            var Boxchecked=false;
            for(var i=0,l=checkboxs.length;i<l;i++)
            {
                if(checkboxs[i].checked)
                {
                  var TreeselectVal = document.getElementsByClassName("treeselect_"+checkboxs[i].id);
                  let  Treeresult = TreeselectVal[0].textContent.split("Select...");
                  if(Treeresult[0]!="" || Treeresult[1]!="")
                  {
                    document.getElementById("treeselect_err_"+checkboxs[i].id).innerHTML="";
                    TreeselectErr = false;
                  }else{
                    TreeselectErr = true;
                    document.getElementById("treeselect_err_"+checkboxs[i].id).innerHTML="Please select values";
                  }
                }
            }
          }
          if(TreeselectErr == false )
          {
            //event.target.reset();
            //console.log('form is valid', this.model);
            this.saveOverrideModule();
            return true;
          }else{
            event.preventDefault()
            return false;
          }
        },
        valthisform()
        {
            var checkboxs=document.getElementsByName("projectIdCheck");
            var Boxchecked=false;
            console.log("validation form");
            for(var i=0,l=checkboxs.length;i<l;i++)
            {
              console.log("validation form 1");
                if(checkboxs[i].checked)
                {
                    Boxchecked=true;
                    break;
                }
            }
            if(Boxchecked)
            return true;
            else
            return false;
        },
        //to get project and role list
        getProjectModuleTree(projectid,pos, event, roleid, items, action){
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.input = ({
              projectid: projectid,
              roleid: roleid
            });
            axios({
                  method: 'POST',
                  'url': apiUrl.api_url + 'getParentChiledURLS_tree',
                  data: this.input,
                  headers: {
                      'Authorization': 'Bearer ' + myStr
                  }
                })
                .then(result => {

                  if(result.data.length > 0)
                  {

                    if(action!="edit" && event!=null && event.target.checked===false)
                    {
                      this.options[projectid] =[];
                      this.form.projectidchk[projectid] = false;
                      this.form.values[projectid]=items.arr;

                    }else{
                    // console.log(pos);
                      //console.log(result.data);
                      this.options[projectid] =result.data;
                      if(items!=undefined){
                        //console.log(this.options[pos]);

                        this.form.projectidchk[projectid] = true;
                        this.form.values[projectid]=items.arr;

                      }
                    }
                    this.$forceUpdate();
                  }else{
                    if(event.target.checked===true)
                    {
                      document.getElementById("treeselect_err_"+projectid).innerHTML="Data is not available for this user. Please contact with superadmin.";
                    }else{
                      this.options[projectid] =[];
                      document.getElementById("treeselect_err_"+projectid).innerHTML="";
                    }
                  }
                }, error => {
                    console.error(error)
                })
        },
        resetForm() {
            this.username = '';
            this.email = '';
            this.adduser.firstname = '';
            this.adduser.username = '';
            this.adduser.email = '';
            this.adduser.password = '';
            this.adduser.confirmpassword = '';
            this.roleid = '';
            this.useraction = 'add';
            this.projectid = [];
            this.projectroleid = [];
            this.status = '';
            this.$validator.reset();
            this.errors.clear();
            this.getUserData();
        },
    }
}



// WEBPACK FOOTER //
// ./src/views/components/appUserProjectRoles/appuserprojectroles.component.js